interface IBreadcrumb {
  items: {
    text: string;
    href?: string;
    active?: boolean;
  }[];
}

const Breadcrumb = ({ items }: IBreadcrumb) => {
    return (
        <div>
            <ol className="breadcrumb" style={{ background: 'transparent' }}>
            {items.map((item, index) => (
                <li key={index} className={`breadcrumb-item ${item.active ? 'active' : ''}`}>
                {item.active ? (
                    <span style={{
                        fontWeight: 500,
                    }}>{item.text}</span>
                ) : (
                    <a href={item.href}>{item.text}</a>
                )}
                </li>
            ))}
            </ol>
        </div>
        )
}

export default Breadcrumb
